import React, { FC, useEffect, useState } from 'react'

import {
  Accordion,
  AccordionContent,
  AccordionItem,
  AccordionTrigger,
} from '../../../../../ui/accordion'
import customImageComponent from '../../../../../common/CustomImageComponent'
import { HorseRequiredFieldsCard } from '../../cards/HorseRequiredFieldsCard/HorseRequiredFieldsCard'
import { HorseProfileCard } from '../../cards/HorseProfileCard/HorseProfileCard'
import { TrackingNumbersCard } from '../../cards/TrackingNumbersCard/TrackingNumbersCard'
import { HorseMembershipsCard } from '../../cards/HorseMembershipsCard/HorseMembershipsCard'
import { PaperworkCard } from '../../cards/PaperworkCard/PaperworkCard'

import {
  getHorseRequiredFields,
  hasInvalidRequiredField,
} from '../../../../../../helpers/requiredFields'
import { cn } from '../../../../../../lib/utils'

import { IHorsesWithPaperwork } from '../HorsesTab/HorsesTab'

interface HorseTabItemProps {
  index: number
  activeTab?: 'registrar' | 'overview'
  item: IHorsesWithPaperwork
  requiredHorseFields?: string[]
  horsesWithPaperwork: IHorsesWithPaperwork[]
  setHorsesWithPaperwork: (state: IHorsesWithPaperwork[]) => void
}
export const HorseTabItem: FC<HorseTabItemProps> = ({
  index,
  item,
  requiredHorseFields,
  horsesWithPaperwork,
  setHorsesWithPaperwork,
  activeTab,
}) => {
  const [issues, setIssues] = useState(0)

  useEffect(() => {
    const fields = getHorseRequiredFields({
      horse: item.horse,
      paperwork: item.paperwork,
      eventRequiredHorseFields: requiredHorseFields,
    })
    const fieldsFiltered = fields.filter((field) => !hasInvalidRequiredField(field))
    setIssues(fields.length - fieldsFiltered.length || 0)
  }, [requiredHorseFields, item])

  return (
    <Accordion className="border-t-black/10 border-t" type="single" collapsible>
      <AccordionItem value={`item-${item.horse.id}`}>
        <AccordionTrigger
          className={cn(
            activeTab === 'overview' && 'pointer-events-none [&_.accordion-arrow-icon]:hidden'
          )}
        >
          <div className="flex items-center gap-3">
            <div className="w-[45px] h-[45px] rounded-md overflow-hidden border border-black/10">
              {customImageComponent(
                item.horse.horseProfilePicture,
                item.horse.horseName,
                'w-full h-full object-cover'
              )}
            </div>
            <div>
              <h5 className="text-sm text-black">{item.horse.horseName}</h5>
              <p className="text-xs text-black/50 mt-1">
                {activeTab !== 'overview' &&
                  (issues > 0 ? `${issues} issue${issues > 1 ? 's' : ''}` : 'No issues')}
              </p>
            </div>
          </div>
          {activeTab === 'overview' && (
            <div className="font-normal rounded-full py-1 px-3 text-SeabiscuitRedThemeColor bg-SeabiscuitRedThemeColor/5">
              {issues} issue{issues > 1 ? 's' : ''}
            </div>
          )}
        </AccordionTrigger>
        <AccordionContent
          className={cn(
            'grid gap-5',
            activeTab === 'registrar' ? 'grid-cols-1' : 'grid-cols-1 md:grid-cols-2'
          )}
        >
          <div className="flex flex-col gap-5">
            <HorseRequiredFieldsCard
              index={index}
              horse={item.horse}
              paperwork={item.paperwork}
              eventRequiredHorseFields={requiredHorseFields}
              horsesWithPaperwork={horsesWithPaperwork}
              setHorsesWithPaperwork={setHorsesWithPaperwork}
              isEditable={true}
            />
            <TrackingNumbersCard
              index={index}
              horse={item.horse}
              horsesWithPaperwork={horsesWithPaperwork}
              setHorsesWithPaperwork={setHorsesWithPaperwork}
              isEditable={true}
            />
          </div>
          <div className="flex flex-col gap-5">
            <HorseProfileCard
              index={index}
              horse={item.horse}
              horsesWithPaperwork={horsesWithPaperwork}
              setHorsesWithPaperwork={setHorsesWithPaperwork}
              isEditable={true}
            />
            <HorseMembershipsCard
              index={index}
              horse={item.horse}
              horsesWithPaperwork={horsesWithPaperwork}
              setHorsesWithPaperwork={setHorsesWithPaperwork}
              isEditable={true}
            />
            <PaperworkCard
              index={index}
              paperwork={item.paperwork}
              horsesWithPaperwork={horsesWithPaperwork}
              setHorsesWithPaperwork={setHorsesWithPaperwork}
              isEditable={true}
            />
          </div>
        </AccordionContent>
      </AccordionItem>
    </Accordion>
  )
}
